var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilledGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#38CB89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4821 8.21415C18.125 7.857 17.5893 7.857 17.2321 8.21415L10.5357 14.9106L7.76786 12.1427C7.41071 11.7856 6.875 11.7856 6.51786 12.1427C6.16071 12.4999 6.16071 13.0356 6.51786 13.3927L9.91071 16.7856C10.0893 16.9641 10.2679 17.0534 10.5357 17.0534C10.8036 17.0534 10.9821 16.9641 11.1607 16.7856L18.4821 9.46415C18.8393 9.107 18.8393 8.57129 18.4821 8.21415Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilledGreen);
export default __webpack_public_path__ + "static/media/check-circle-filled-green.3659bdc30b12f282bf3229cbae44f7a9.svg";
export { ForwardRef as ReactComponent };